import React from "react";
import {
  FaCoffee,
  FaSpa,
  FaShuttleVan,
  FaSnowflake,
  FaParking,
  FaConciergeBell,
  FaWifi,
  FaUsers,
  FaDumbbell,
  // FaSmokingBan,
} from "react-icons/fa";

import "./Facilities.css";

const isAvailable = (val) => {
  if (!val) return false;
  if (typeof val === "boolean") return val;
  if (typeof val === "string") return val.toLowerCase() === "yes" || val.toLowerCase() === "available";
  return false;
};

const Facilities = ({ property }) => {
  if (!property) return null;

  const availableFacilities = [];

  // ✅ Breakfast
  const hasBreakfast = property.rooms?.some(r => isAvailable(r.breakfast?.available));
  if (hasBreakfast) {
    availableFacilities.push({ icon: <FaCoffee />, label: "Breakfast" });
  }

  // ✅ Spa
  if (isAvailable(property.poolAndSpa?.spa)) {
    availableFacilities.push({ icon: <FaSpa />, label: "Spa" });
  }

  // ✅ Airport shuttle
  if (isAvailable(property.transportation?.airportShuttle)) {
    availableFacilities.push({ icon: <FaShuttleVan />, label: "Airport shuttle" });
  }

  // ✅ Air conditioning
  const hasAC = property.rooms?.some(r => isAvailable(r.amenities.TopAmenities?.airConditioning));
  if (hasAC) {
    availableFacilities.push({ icon: <FaSnowflake />, label: "Air conditioning" });
  }

  // ✅ Parking
  if (isAvailable(property.transportation?.parking)) {
    availableFacilities.push({ icon: <FaParking />, label: "Free on-site parking" });
  }

  // ✅ Room service
  if (isAvailable(property.physicalDistancing?.roomService)) {
    availableFacilities.push({ icon: <FaConciergeBell />, label: "Room service" });
  }

  // ✅ Wifi
  if (isAvailable(property.selfCheckIn?.mobileInternetProperty)) {
    availableFacilities.push({ icon: <FaWifi />, label: "Free Wifi" });
  }

  // ✅ Family rooms
  if (isAvailable(property.topPropertyFacilities?.familyRooms)) {
    availableFacilities.push({ icon: <FaUsers />, label: "Family rooms" });
  }

  // ✅ Fitness center
  if (isAvailable(property.poolAndSpa?.fitnessCenter)) {
    availableFacilities.push({ icon: <FaDumbbell />, label: "Fitness center" });
  }

  // ✅ Non-smoking rooms
  // if (property.rules?.smokingAllowed === false) {
  //   availableFacilities.push({ icon: <FaSmokingBan />, label: "Non-smoking rooms" });
  // }

  return (
    <div className="container facilities-wrapper">
      {availableFacilities.map((item, idx) => (
        <div key={idx} className="facility-box">
          <span className="facility-icon">{item.icon}</span>
          <span className="facility-text">{item.label}</span>
        </div>
      ))}
    </div>
  );
};
export default Facilities;
